const exclusiveOptionKeyword = ":exclusive";

/**
 * Ensures that only the exclusive checkbox is checked.
 */
function activateExclusiveCheckboxes() {
    $("input[type=checkbox]:not(.exclusive)").on("ifChanged", function(e) {
        if (!$(this).parent().hasClass("checked")) {
            const checkboxGroupName = $(this).prop('name');
            $("input[type=checkbox][name=" + checkboxGroupName + "].exclusive").iCheck('uncheck');
        }
    });

    $("input[type=checkbox].exclusive").on("ifChanged", function(e){
        if (!$(this).parent().hasClass('checked')) {
            const checkboxGroupName = $(this).prop('name');
            $("input[type=checkbox][name=" + checkboxGroupName + "]:not(.exclusive)").iCheck('uncheck');
        }
    });
}

/**
 * Checks if the given value is an exclusive option.
 * 
 * @param {string} value
 * @returns {boolean}
 */
function isExclusiveOption(value) {
    return value.trimEnd().endsWith(exclusiveOptionKeyword);
}

/**
 * Removes the exclusive option keyword from the given value. If the given value is not an exclusive option, the value is returned as is.
 * 
 * @param {string} value
 * @returns {string}
 * @see isExclusiveOption
 * @see exclusiveOptionKeyword
 */
function removeExclusiveOptionKeyword(value) {
    if (!isExclusiveOption(value)) {
        return value;
    }

    return value.trimEnd().slice(0, -exclusiveOptionKeyword.length);
}